/** Spam-check signals in plain words (from crm-automations' forms screen, commit 5b8fbe0). */
const SIGNALS: Record<string, string> = {
  "name:first-equals-last": "first and last name are the same",
  "phone:ru-11-digit": "Russian-style phone number",
  "phone:leading-08-intl": "foreign phone number starting 08",
  "phone:bad-length": "phone number too short",
  "salutation:dear-admin": "“Dear admin” greeting",
  "salutation:419-opener": "“Dearest beloved” opener",
  "subject:own-domain": "our own domain in the subject",
  "message:non-latin-script": "message in another alphabet",
  "message:own-domain": "our own domain in the message",
  "message:multi-url": "two or more links",
  "message:link-shortener": "link shortener",
  "name:consonant-run": "gibberish name",
  "message:seo-outreach": "SEO / backlink pitch",
  "message:optout-footer": "bulk-mail opt-out line",
  "message:free-quote-pitch": "“free quote” sales pitch",
  "blocklist:email": "address on the spam blocklist",
  "blocklist:domain": "domain on the spam blocklist",
  "blocklist:name": "name on the spam blocklist",
  "blocklist:phone": "phone on the spam blocklist",
  "site:honeypot": "filled the hidden spam-trap field",
  "site:turnstile-failed": "failed the Cloudflare check",
  "site:blocked": "the site's filter blocked it",
};

export function plainSignal(sig: string): string {
  if (SIGNALS[sig]) return SIGNALS[sig];
  if (sig.startsWith("blocklist:")) return "spam blocklist (" + sig.slice(10) + ")";
  if (sig.startsWith("site:timing:")) return "submitted too fast or without the form's timer";
  if (sig.startsWith("site:")) return "the site flagged: " + sig.slice(5).replace(/[-_]/g, " ");
  return sig.replace(/[:_-]/g, " ");
}

/** The spam signals stored on a submission's result, if any. */
export function signalsOf(result: Record<string, unknown> | null | undefined): string[] {
  const spam = (result?.spam ?? null) as { signals?: unknown } | null;
  return Array.isArray(spam?.signals) ? (spam!.signals as string[]) : [];
}
